import { executeApiCall } from 'services/api';
import { getLoaders } from 'entities/hooks/load';

import { User, UserAction } from './types';
import { Team } from '../teams';
import { sortByName } from 'utils/array';

type UserWithTeam = Omit<User, 'team'> & { team: Team };

export const userLoaders = getLoaders({
  teamUsers: {
    load: async ({ team }: { team: string }): Promise<User[]> => {
      return executeApiCall({
        path: '/users',
        method: 'get',
        payload: { team },
      });
    },

    defaultParser: sortByName,
  },

  find: {
    load: async ({ id }: { id: string }): Promise<UserWithTeam> => {
      return executeApiCall({
        path: `/users/${id}`,
        method: 'get',
      });
    },
  },

  salesUsers: {
    load: async (): Promise<User[]> => {
      return executeApiCall({
        path: '/users/sales',
        method: 'get',
      });
    },

    defaultParser: sortByName,
  },

  bulkFind: {
    load: async (payload: { ids: string[] }): Promise<User[]> => {
      return executeApiCall({
        path: '/users/bulk-load',
        method: 'post',
        payload,
      });
    },

    defaultParser: sortByName,
  },

  leaders: {
    load: async ({ teams }: { teams: string[] }): Promise<User[]> => {
      return executeApiCall({
        path: '/users/leaders',
        method: 'get',
        payload: {
          teams: teams.filter(Boolean).join(','),
        },
      });
    },

    defaultParser: sortByName,
  },

  userActions: {
    load: async ({
      userId,
      ...payload
    }: {
      userId: string;
      paginationToken?: string;
    }): Promise<{
      items: UserAction[];
      paginationToken?: string;
    }> => {
      return executeApiCall({
        path: `/users/actions/${userId}`,
        method: 'get',
        payload,
      });
    },
  },
});
